import React, { useState } from 'react';
import { Container, Divider, Heading } from '@hover/blueprint';
import { IMeasureRoofFAQ } from '../../interfaces/IMeasureRoofFAQ';
import { MEASURE_ROOF_FAQ } from '../../constants';
import { Accordion } from '../ui';

const FAQ: React.FC = () => {
  const [current, setCurrent] = useState<string | null>(null);

  const onSelectAccordion = (title: string): void => {
    if (current === title) {
      setCurrent(null);
    } else {
      setCurrent(title);
    }
  };
  return (
    <Container
      mb={1000}
      centerContent
      maxW="900px"
      px={{ base: 500, tablet: '56px' }}
      py={{ base: 0, desktop: 1000 }}
    >
      <Heading
        as="h2"
        fontWeight={{ base: 600, desktop: 600 }}
        size={{ base: 500, desktop: 700 }}
        marginBottom={{ base: 800, desktop: '88px' }}
      >
        Frequently asked questions
      </Heading>
      <Divider
        borderColor="neutral.500"
        my={0}
        borderWidth="1px"
        borderTopWidth={0}
      />
      {MEASURE_ROOF_FAQ.map((faq: IMeasureRoofFAQ) => (
        <Accordion
          isExpanded={faq.title === current}
          onClick={() => {
            onSelectAccordion(faq.title);
          }}
          maxW="790px"
          title={faq.title}
          content={faq.content}
          key={faq.id}
        />
      ))}
    </Container>
  );
};

export default FAQ;
